import { render } from "./ContactForm.vue?vue&type=template&id=774cc34a&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=774cc34a&lang=less&scoped=true"
import "./ContactForm.vue?vue&type=style&index=1&id=774cc34a&lang=less&scoped=true"
import "./ContactForm.vue?vue&type=style&index=2&id=774cc34a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774cc34a"]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QParallax from 'quasar/src/components/parallax/QParallax.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QParallax,QBtn,QSeparator,QForm,QInput,QSelect});
